import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Center,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  HStack,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Portal,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";

import { FormEvent, useEffect, useRef, useState } from "react";
import { HiArrowNarrowLeft, HiOutlinePencil } from "react-icons/hi";
import { IoMdSettings } from "react-icons/io";
import { MdDelete, MdOutlineAdd } from "react-icons/md";
import { useNavigate, useParams } from "react-router-dom";
import { AssignCourseModal } from "../../../components/admin/course/AssignCourseModal";
import Loading from "../../../components/common/Loading";
import cmd from "../../../img/cmd.svg";
import mounted from "../../../img/mounted.svg";
import notes from "../../../img/notes.svg";
import { IAllCourse } from "../../../models/allcourse.model";
import {
  IAvailableCourse,
  ICourseTrainer,
} from "../../../models/trainee-course.model";
import AdminHelpers from "../../../services/admin/admin.service";
import coursesService from "../../../services/courses.service";
import registrationService from "../../../services/registration.service";
import trainercoursesService from "../../../services/trainer/trainercourses.service";
import { getFullDate } from "../../../utils/classOfDegree";
import Adminroutes from "../routes";
import DeleteTrainerModal from "../../../components/admin/course/DeleteTrainerModal";

const EachAdminCourse = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const { course_id } = useParams();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const editTrainerDisclosure = useDisclosure();
  const [assigncourse, setAssignCourse] = useState(false);
  const [courseId, setCourseId] = useState("");
  const cancelRef = useRef(null);
  const [reload, setReload] = useState(false);
  const [trainerIds, setTrainerIds] = useState<string[]>();
  const [trainer_id, setTrainerId] = useState<string[]>();
  const [availabilty_id, setAvailabilityId] = useState<string>();
  const [isOpenAlert, setIsOpen] = useState(false);
  const onCloseAlert = () => setIsOpen(false);
  const [course, setCourse] = useState<IAllCourse>();
  const [loading, setLoading] = useState(true);
  const [isDeleting, setIsDeleting] = useState(false);
  const [availablePeriods, setAvailablePeriods] =
    useState<IAvailableCourse[]>();
  const [isPostingModalOpen, setIsPostingModalOpen] = useState(false);
  const [postingFormData, setPostingFormData] = useState({
    course_availability_id: "",
    can_change_discipline: null as boolean | null,
    can_change_specialization: null as boolean | null,
    can_change_posting_centre: null as boolean | null,
    can_choose_posting_centre: null as boolean | null,
  });

  useEffect(() => {
    registrationService
      .getEachCourse(course_id)
      .then((response) => {
        setCourse(response);
      })
      .catch((err) => err);
    getAvailabePeriods();
  }, [course?.id, reload]);

  const openPostingModal = (availabilityId: any) => {
    setPostingFormData({
      ...postingFormData,
      course_availability_id: availabilityId.toString(),
    });
    setIsPostingModalOpen(true);
  };

  const closePostingModal = () => {
    setIsPostingModalOpen(false);
  };

  const handlePostingSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    try {
      await AdminHelpers.updateCourseAvailability(postingFormData);
      toast({
        title:
          course && course.status === 1 && course.is_program !== 1
            ? "Course Availability"
            : "Program Availability",
        description: "Posting updated successfully",
        status: "success",
        duration: 3000,
      });
    } catch (err) {
      toast({
        title:
          course && course.status === 1 && course.is_program !== 1
            ? "Course Availability"
            : "Program Availability",
        description: "Something went wrong",
        status: "error",
        duration: 3000,
      });
    } finally {
      closePostingModal();
    }
  };

  const reloadData = () => {
    setReload(!reload);
  };

  const getAvailabePeriods = async () => {
    if (course) {
      const allAvailableCourses = await coursesService.getAvailableCourses();
      // console.log(allAvailableCourses, "available from endpoint"); // i noticed available courses returns records with same course id multiple times
      const available_periods = allAvailableCourses.filter(
        (each) => each.course_id == course.id
      );
      let result;
      for (let index = 0; index < available_periods.length; index++) {
        result = await trainercoursesService.getCourseTrainers(
          available_periods[index].uuid
        );
        available_periods[index]["trainers"] = result.data;
      }
      setLoading(false);

      setAvailablePeriods(available_periods);
    }
  };

  const openAssignCourseModal = async (
    id: string,
    trainers: ICourseTrainer[] | undefined
  ) => {
    setAssignCourse(true);
    const ids: string[] = [];
    trainers && trainers.forEach((trainer) => ids.push(trainer.id.toString()));
    setTrainerIds(ids);
    setCourseId(id);
    onOpen();
  };

  const opendeletetrainerAlert = (trainerId: string, availaibleId: string) => {
    setTrainerId([trainerId]);
    setAvailabilityId(availaibleId);
    setIsOpen(true);
  };

  const deletetrainer = async () => {
    setIsDeleting(true);
    try {
      const remove_trainer = await trainercoursesService.removeCourseTrainer(
        availabilty_id,
        { trainers: trainer_id }
      );
      if (remove_trainer) {
        setAvailabilityId("");
        setTrainerId([]);
        onCloseAlert();
        reloadData();
        setIsDeleting(false);
        toast({
          title: "Remove Trainer",
          description: remove_trainer.message,
          status: "success",
        });
      } else {
        setAvailabilityId("");
        setTrainerId([]);
        onCloseAlert();
        setIsDeleting(false);
        toast({
          title: "Remove Trainer",
          description: remove_trainer.message,
          status: "error",
        });
      }
    } catch (error) {
      setIsDeleting(false);
    }
  };

  const OpenEditTrainerModal = () => {
    editTrainerDisclosure.onOpen();
  };

  const viewTraineeCluster = async (course_id: string) => {
    navigate(Adminroutes.ReviewTraineeClusterLink(course_id));
  };

  //setCourses(courses.filter((course) => course.status === 1 && course.is_program !== 1));
  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box
          bg="#F9F8F8"
          px={["20px", "100px"]}
          py="50px"
          minHeight={"100vh"}
          height={"auto"}
        >
          <Box>
            <Box
              mb="60px"
              display="flex"
              alignItems="center"
              border="1px solid #616161"
              px="5px"
              py="7px"
              width="145px"
              borderRadius="2px"
              cursor="pointer"
            >
              <HiArrowNarrowLeft color="#616161" fontSize="20px" />
              <Text
                fontSize="14px"
                color="#616161"
                pl="5px"
                onClick={() => navigate(-1)}
                fontWeight={700}
              >
                Go Back
              </Text>
            </Box>

            <Flex
              borderRadius={"10px"}
              pt="50px"
              pb="60px"
              px={["30px", "30px", "40px", "80px"]}
              bg={"white"}
              flexDirection={["column", "column", "row", "row"]}
            >
              <Box
                width={["100%", "100%", "100%", "75%"]}
                mr={["0px", "0px", "20px", "20px"]}
              >
                <Text
                  pb="12px"
                  textTransform={"capitalize"}
                  fontSize="30px"
                  fontWeight="800"
                >
                  {course?.name.toLocaleLowerCase()}
                </Text>
                <Text
                  textTransform={"capitalize"}
                  fontSize="14px"
                  fontWeight="400"
                >
                  {course?.description}
                </Text>
              </Box>
              <Box>
                <HStack mb="20px" spacing="20px">
                  <Center
                    width="50px"
                    height="50px"
                    bg="gray.200"
                    borderRadius="25px"
                  >
                    <Image src={notes} />
                  </Center>
                  <Box>
                    <Text
                      textAlign={"left"}
                      color="#616161"
                      fontSize="13px"
                      fontWeight="400"
                    >
                      {course && course.status === 1 && course.is_program !== 1
                        ? "Course Type"
                        : "Program Type"}
                    </Text>
                    <Text
                      textTransform={"capitalize"}
                      fontSize="15px"
                      fontWeight="600"
                    >
                      {" "}
                      {/* {course &&
                        course.type &&
                        course.type.name.toLocaleLowerCase()} */}
                      {course &&
                        course.course_type &&
                        course.course_type.name.toLocaleLowerCase()}
                    </Text>
                  </Box>
                </HStack>
                <HStack mb="20px" spacing="20px">
                  <Center
                    width="50px"
                    bg="gray.200"
                    height="50px"
                    borderRadius="25px"
                  >
                    <Image src={cmd} />
                  </Center>
                  <Box>
                    <Text color="#616161" fontSize="13px" fontWeight="400">
                      {course && course.status === 1 && course.is_program !== 1
                        ? "Course Code"
                        : "Program Code"}
                    </Text>
                    <Text fontSize="15px" fontWeight="600">
                      {/* {course?.type?.status} */}
                      {course?.code}
                    </Text>
                  </Box>
                </HStack>
                <HStack mb="20px" spacing="20px">
                  <Center
                    width="50px"
                    bg="gray.200"
                    height="50px"
                    borderRadius="25px"
                  >
                    <Image src={mounted} />
                  </Center>

                  <Box>
                    <Text color="#616161" fontSize="13px" fontWeight="400">
                      {" "}
                      {course && course.status === 1 && course.is_program !== 1
                        ? "Course Category"
                        : "Program Category"}
                    </Text>
                    <Text fontSize="15px" fontWeight="600">
                      {course && course.category && course.category.name}
                    </Text>
                  </Box>
                </HStack>
              </Box>
            </Flex>

            <Box mt="40px" width={"100%"} py="15px" pl="30px" bg={"white"}>
              <Text fontWeight={"700"} fontSize={"21px"} color={"#2B2B2B"}>
                Availability
              </Text>
            </Box>
            <Box
              bg={"white"}
              py="10px"
              px="10px"
              maxWidth={"100%"}
              overflowX={"scroll"}
              className="scroll-hidden"
            >
              <Table variant="simple">
                <Thead>
                  <Tr>
                    <Th>Session</Th>
                    <Th>Term</Th>
                    <Th>Training Start Date</Th>
                    <Th>Training End Date</Th>
                    <Th>Assigned to</Th>
                    <Th>Options</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {availablePeriods &&
                    availablePeriods.map((each, index: number) => (
                      <Tr key={index}>
                        <Td>
                          <Text
                            fontSize={"14px"}
                            textTransform={"capitalize"}
                            onClick={() => {
                              // Your viewTraineeCluster logic here
                            }}
                          >
                            {each.session.title}
                          </Text>
                        </Td>
                        <Td>
                          <Text fontSize={"14px"} textTransform={"capitalize"}>
                            {each.term.title}
                          </Text>
                        </Td>
                        <Td>
                          <Text fontSize={"14px"} textTransform={"capitalize"}>
                            {getFullDate(each.training_start)}
                          </Text>
                        </Td>
                        <Td>
                          <Text fontSize={"14px"} textTransform={"capitalize"}>
                            {getFullDate(each.training_end)}
                          </Text>
                        </Td>
                        <Td>
                          <AvatarGroup size="sm" max={3}>
                            {each?.trainers?.map((eachTrainer, ind) => (
                              <Avatar key={ind} name={eachTrainer.name} />
                            ))}
                          </AvatarGroup>
                        </Td>
                        <Td>
                          <HStack spacing={2}>
                            <Center
                              border="1px solid"
                              borderRadius="5px"
                              borderColor="#E5E5E5"
                              width="30px"
                              height="30px"
                              onClick={() => {
                                openAssignCourseModal(each.uuid, each.trainers);
                              }}
                            >
                              <MdOutlineAdd fontSize="24px" />
                            </Center>
                            <Center
                              border="1px solid"
                              borderRadius="10px"
                              borderColor="#E5E5E5"
                              width="30px"
                              height="30px"
                              cursor="pointer"
                              onClick={() => {
                                OpenEditTrainerModal();
                              }}
                            >
                              <HiOutlinePencil />
                            </Center>
                            <DeleteTrainerModal
                              isOpen={editTrainerDisclosure.isOpen}
                              onClose={editTrainerDisclosure.onClose}
                              deletetrainer={deletetrainer}
                              each={each}
                              opendeletetrainerAlert={opendeletetrainerAlert}
                            />
                            {course &&
                              course.status === 1 &&
                              course.is_program === 1 && ( // Replace with actual condition for showing settings
                                <Center
                                  border="1px solid"
                                  borderRadius="10px"
                                  borderColor="#E5E5E5"
                                  width="30px"
                                  height="30px"
                                  cursor={"pointer"}
                                  onClick={() => openPostingModal(each.id)}
                                >
                                  <IoMdSettings />
                                </Center>
                              )}
                          </HStack>
                        </Td>
                      </Tr>
                    ))}
                </Tbody>
              </Table>
            </Box>
          </Box>
          {assigncourse && (
            <Portal>
              {" "}
              <AssignCourseModal
                isOpened={isOpen}
                onClosed={onClose}
                selectedCourseId={courseId}
                trainerIds={trainerIds}
                updateRecord={reloadData}
              />{" "}
            </Portal>
          )}
          <Portal>
            <AlertDialog
              isOpen={isOpenAlert}
              leastDestructiveRef={cancelRef}
              onClose={onCloseAlert}
            >
              <AlertDialogOverlay zIndex={"1300000"}>
                <AlertDialogContent zIndex={"1300000"}>
                  <AlertDialogHeader fontSize="md" fontWeight="semibold">
                    Remove Trainer
                  </AlertDialogHeader>

                  <AlertDialogBody fontSize={15}>
                    Are you sure? You can't undo this action afterwards.
                  </AlertDialogBody>

                  <AlertDialogFooter>
                    <Button size={"sm"} ref={cancelRef} onClick={onCloseAlert}>
                      Cancel
                    </Button>
                    <Button
                      size={"sm"}
                      colorScheme="red"
                      isLoading={isDeleting}
                      onClick={deletetrainer}
                      ml={3}
                    >
                      Delete
                    </Button>
                  </AlertDialogFooter>
                </AlertDialogContent>
              </AlertDialogOverlay>
            </AlertDialog>
          </Portal>
          <Modal isOpen={isPostingModalOpen} onClose={closePostingModal}>
            <ModalOverlay />
            <ModalContent>
              <ModalHeader fontSize={"22px"}>Update Course Posting</ModalHeader>
              <ModalCloseButton />
              <form onSubmit={handlePostingSubmit}>
                <ModalBody>
                  <FormControl mt={4}>
                    <FormLabel
                      fontSize={"16px"}
                      fontWeight={"700"}
                      lineHeight={"120%"}
                    >
                      Trainee Can Change Discipline ?
                    </FormLabel>
                    <HStack>
                      <Checkbox
                        isChecked={
                          postingFormData.can_change_discipline === true
                        }
                        isIndeterminate={
                          postingFormData.can_change_discipline === null
                        }
                        onChange={() =>
                          setPostingFormData({
                            ...postingFormData,
                            can_change_discipline:
                              postingFormData.can_change_discipline === null
                                ? true
                                : !postingFormData.can_change_discipline,
                          })
                        }
                        colorScheme="red"
                      >
                        Yes
                      </Checkbox>
                      <Checkbox
                        isChecked={
                          postingFormData.can_change_discipline === false
                        }
                        isIndeterminate={
                          postingFormData.can_change_discipline === null
                        }
                        onChange={() =>
                          setPostingFormData({
                            ...postingFormData,
                            can_change_discipline:
                              postingFormData.can_change_discipline === null
                                ? false
                                : !postingFormData.can_change_discipline,
                          })
                        }
                        colorScheme="red"
                      >
                        No
                      </Checkbox>
                    </HStack>
                  </FormControl>
                  <FormControl mt={4}>
                    <FormLabel
                      fontSize={"16px"}
                      fontWeight={"700"}
                      lineHeight={"120%"}
                    >
                      Trainee Can Change Specialization ?
                    </FormLabel>
                    <HStack>
                      <Checkbox
                        isChecked={
                          postingFormData.can_change_specialization === true
                        }
                        isIndeterminate={
                          postingFormData.can_change_specialization === null
                        }
                        onChange={() =>
                          setPostingFormData({
                            ...postingFormData,
                            can_change_specialization:
                              postingFormData.can_change_specialization === null
                                ? true
                                : !postingFormData.can_change_specialization,
                          })
                        }
                        colorScheme="red"
                      >
                        Yes
                      </Checkbox>
                      <Checkbox
                        isChecked={
                          postingFormData.can_change_specialization === false
                        }
                        isIndeterminate={
                          postingFormData.can_change_specialization === null
                        }
                        onChange={() =>
                          setPostingFormData({
                            ...postingFormData,
                            can_change_specialization:
                              postingFormData.can_change_specialization === null
                                ? false
                                : !postingFormData.can_change_specialization,
                          })
                        }
                        colorScheme="red"
                      >
                        No
                      </Checkbox>
                    </HStack>
                  </FormControl>
                  <FormControl mt={4}>
                    <FormLabel
                      fontSize={"16px"}
                      fontWeight={"700"}
                      lineHeight={"120%"}
                    >
                      Trainee Can Change Posting Centre ?
                    </FormLabel>
                    <HStack>
                      <Checkbox
                        isChecked={
                          postingFormData.can_change_posting_centre === true
                        }
                        isIndeterminate={
                          postingFormData.can_change_posting_centre === null
                        }
                        onChange={() =>
                          setPostingFormData({
                            ...postingFormData,
                            can_change_posting_centre:
                              postingFormData.can_change_posting_centre === null
                                ? true
                                : !postingFormData.can_change_posting_centre,
                          })
                        }
                        colorScheme="red"
                      >
                        Yes
                      </Checkbox>
                      <Checkbox
                        isChecked={
                          postingFormData.can_change_posting_centre === false
                        }
                        isIndeterminate={
                          postingFormData.can_change_posting_centre === null
                        }
                        onChange={() =>
                          setPostingFormData({
                            ...postingFormData,
                            can_change_posting_centre:
                              postingFormData.can_change_posting_centre === null
                                ? false
                                : !postingFormData.can_change_posting_centre,
                          })
                        }
                        colorScheme="red"
                      >
                        No
                      </Checkbox>
                    </HStack>
                  </FormControl>
                  <FormControl mt={4}>
                    <FormLabel
                      fontSize={"16px"}
                      fontWeight={"700"}
                      lineHeight={"120%"}
                    >
                      Trainee Can Choose Posting Centre ?
                    </FormLabel>
                    <HStack>
                      <Checkbox
                        isChecked={
                          postingFormData.can_choose_posting_centre === true
                        }
                        isIndeterminate={
                          postingFormData.can_choose_posting_centre === null
                        }
                        onChange={() =>
                          setPostingFormData({
                            ...postingFormData,
                            can_choose_posting_centre:
                              postingFormData.can_choose_posting_centre === null
                                ? true
                                : !postingFormData.can_choose_posting_centre,
                          })
                        }
                        colorScheme="red"
                      >
                        Yes
                      </Checkbox>
                      <Checkbox
                        isChecked={
                          postingFormData.can_choose_posting_centre === false
                        }
                        isIndeterminate={
                          postingFormData.can_choose_posting_centre === null
                        }
                        onChange={() =>
                          setPostingFormData({
                            ...postingFormData,
                            can_choose_posting_centre:
                              postingFormData.can_choose_posting_centre === null
                                ? false
                                : !postingFormData.can_choose_posting_centre,
                          })
                        }
                        colorScheme="red"
                      >
                        No
                      </Checkbox>
                    </HStack>
                  </FormControl>
                </ModalBody>
                <ModalFooter>
                  <Button
                    onClick={closePostingModal}
                    mr={3}
                    colorScheme="brand3"
                  >
                    Cancel
                  </Button>
                  <Button type="submit" colorScheme="red">
                    Apply
                  </Button>
                </ModalFooter>
              </form>
            </ModalContent>
          </Modal>
        </Box>
      )}
    </>
  );
};

export default EachAdminCourse;
